<template>
  <main id="js-page-content" role="main" class="page-content" style="background:#dddae4" data-app>
    <v-container class="pt-0" fluid>
      <v-row align="end">
        <v-col md="3" class="pb-1 pt-0">
          <v-select
            v-model="selectedProcess"
            return-object
            :loading="loadingProcesses"
            :items="processes"
            item-text="text"
            item-value="id"
            label="Proceso"
            hide-details
            prepend-icon="mdi-archive"
            @change="select_process"
            dense
            light>
          </v-select>
        </v-col>
        <v-col md="8" class="pb-1 pt-0">
          <v-sheet class="rounded-pill pl-2 pb-0 border-line">
            <v-text-field
              hide-details
              prepend-icon="mdi-magnify"
              single-line
              dense
              solo
              rounded
            ></v-text-field>
          </v-sheet>
        </v-col>
        <v-col md="1" class="pb-1 px-0 pt-0">
          <v-btn
            style="margin-bottom: 2px"
          >
            Buscar
          </v-btn>
        </v-col>

        <widgets ref="widgets"></widgets>

      </v-row>
      <v-row>
        <template v-for="(element,index) in elements">
          <v-col md="12" :key="'col'+index" class="py-1">
            <twitter-card v-if="element.red_social_id == 1" :key="'tw_card'+index" :tweet="element"></twitter-card>
            <web-card v-else-if="element.red_social_id == 2" :key="'web_card'+index" :extraccion="element"></web-card>
          </v-col>
        </template>
        <v-col md="12">
          <div class="text-center">
            <v-pagination
              v-model="page"
              :length="Math.ceil(element_count/20)"
              :total-visible="7"
            ></v-pagination>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </main>
</template>

<script>
import Widgets from "@/components/widgets/Widgets.vue"
import apiExtract from "@/api/modules/extract";
import TwitterCard from "@/components/cards/TwitterCard.vue";
import WebCard from "@/components/cards/WebCard.vue";
// import DonutChart from '@/components/charts/DonutChart.vue';

export default {
  data(){
    return{
      elements:[],
      processes:[],
      selectedProcess: null,
      loadingProcesses:true,
      element_count:0,
      page:1,
      page_size:20
    }
  },
  components:{
    TwitterCard,
    WebCard,
    Widgets
  },
  watch:{
    page(val){
      this.$router.push({ query: Object.assign({}, this.$route.query, {
        process_id:this.selectedProcess.id, page:val, page_size:this.page_size
      }) })
      this.getElements()
    }
  },
  computed:{
    colors_t_w(){
      return ['#1da1f2',this.$vuetify.theme.currentTheme.accent]
    },
    
  },
  methods:{
    select_process(){
      this.$router.push({ query: Object.assign({}, this.$route.query, {
        process_id:this.selectedProcess.id, page:this.page, page_size:this.page_size
      }) })
      this.getElements()
      this.$refs.widgets.refrescar()
    },
    getElements(){
      apiExtract.getAllElements(this.$route.query.process_id, this.$route.query.page, this.$route.query.page_size)
      .then((resp)=>{
          if(resp){
            this.elements = resp.data;
            this.element_count = resp.total;
          }
      })
    },
  },
  mounted(){
    apiExtract.getProcesses()
    .then((resp)=>{
        if(resp.status){
            this.processes = resp.processes;
            this.loadingProcesses = false;
            this.selectedProcess = (this.$route.query.process_id == null ? null : this.processes.filter( x => x.id == this.$route.query.process_id)[0])
        }
    });
    this.getElements()
    setTimeout(this.$refs.widgets.refrescar, 2000);
  },
}
</script>

<style>
.borde{
  box-shadow: 4px 0px 4px -1px rgba(0,0,0,0.25);
  -webkit-box-shadow: 4px 0px 4px -1px rgba(0,0,0,0.25);
  -moz-box-shadow: 4px 0px 4px -1px rgba(0,0,0,0.25);
}
.border-line{
  border-style: solid;
  border-width: 1px;
  border-style: solid;
  border-color: #000;
}
</style>
